export enum CARD_STATUSES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELED = 'canceled',
}

export enum CARD_TYPES {
  VIRTUAL = 'virtual',
  PHYSICAL = 'physical',
}

export enum CONNECTED_ACCOUNT_STATUSES {
  ACTIVE = 'active',
  PENDING = 'pending',
  DELETED = 'deleted',
  PENDING_VERIFICATION = 'pendingVerification',
}
